<mat-form-field [className]="'example-full-width'">
    <input 
        type="text" 
        [placeholder]="placeHolder" 
        aria-label="Number" 
        matInput 
        [formControl]="formControl"
        [matAutocomplete]="auto">
        <mat-icon *ngIf="selectedOption" class="clear autocomple-clear" matSuffix (click)="clearCombo()">clear</mat-icon>
        <mat-autocomplete #auto="matAutocomplete" >
              <mat-option *ngFor="let option of filteredOptions | async" 
                [value]="option.displayText" 
                (onSelectionChange)="onSelect($event)" >
                {{option.displayText}}
              </mat-option>  
         <!-- dasdasda -->
        </mat-autocomplete>
    <!-- <mat-hint align="start">
        <strong>Müşterileri Goster bakalim dasdasda sada</strong>
    </mat-hint> -->
</mat-form-field>